export default {
  nav: {
    home: "首頁",
    aboutUs: "關於我們",
    products: "產品",
    quality: "品質",
    sustainability: "永續發展",
    globalReach: "全球市場",
    contact: "聯繫我們",
  },
  quick: {
    whatsapp: "WhatsApp",
    zalo: "Zalo",
    wechat: "微信",
    qrTitle: "透過 {{app}} 與我們聯絡",
    qrDesc: "使用 {{app}} 掃描下方 QR 碼，即可直接與我們的出口團隊溝通。",
    qrPlaceholder: "{{app}} QR 碼",
    qrStepsTitle: "掃碼方法",
    qrStep1: "在手機上開啟 {{app}}，進入掃碼介面。",
    qrStep2: "將鏡頭對準下方 QR 碼，開啟我們的聯絡人頁面。",
    qrStep3: "傳送訊息，我們的團隊將於一個工作天內回覆。",
    qrClose: "關閉",
    callNow: "立即致電",
    callTitle: "致電我們的出口團隊",
    callDesc: "直接聯繫出口部門 —— 工作時間內我們隨時為您提供支援。",
    callLabel: "電話號碼",
    callCopy: "複製號碼",
    callCopied: "已複製",
    callClose: "關閉",
    open: "開啟快捷聯繫",
    close: "關閉快捷聯繫",
  },
  footer: {
    heading: "攜手共創\n更美好的未來",
    cta: "立即聯繫",
    rights: "© 2026 EverRice 版權所有。",
    email: "info@everrice.vn",
    location: "越南 胡志明市",
    company: "永禾有限公司",
  },
  home: {
    hero: {
      eyebrow: "您值得信賴的合作夥伴",
      title: "讓越南大米走向世界",
      sub1: "優質大米 。永續發展。",
      sub2: "共創美好未來，造福人與社區。",
      cta: "我們的產品",
    },
    about: {
      eyebrow: "關於 EverRice",
      title1: "扎根越南",
      title2: "攜手共進，走向全球",
      desc: "我們是一家越南大米出口企業，致力於將高品質大米供應到全球市場，同時為農民、合作夥伴與社區創造永續價值。",
      cta: "了解更多",
      features: [
        { title: "卓越品質", desc: "精選自肥沃的良田" },
        { title: "全球供應", desc: "深受全球合作夥伴信賴" },
        { title: "永續成長", desc: "為了人們、社區與環境" },
      ],
    },
    products: {
      eyebrow: "我們的產品",
      title: "越南好米，\n成就美好未來",
      desc: "從優質香米到精選白米、糯米及各類特色米種，EverRice 自豪地將越南優質大米帶向世界，讓越南好米的卓越品質與獨特風味走進全球各地的餐桌。",
      cta: "瀏覽產品",
      items: [
        { name: "香米", desc: "香氣清雅，口感細膩" },
        { name: "白米", desc: "品質穩定" },
        { name: "糯米", desc: "營養豐富" },
        { name: "特色米", desc: "品種獨特" },
      ],
    },
    stats: [
      { value: "15+", label: "出口國家" },
      { value: "20萬", label: "年發貨噸數" },
      { value: "4萬", label: "噸/月供應能力" },
      { value: "14", label: "年專業經驗" },
    ],
    globalReach: {
      eyebrow: "全球市場",
      title: "從越南走向世界",
      desc: "我們向亞洲、北美、歐洲、非洲及其他地區的市場供應優質大米。",
      cta: "我們的市場",
    },
    sustainability: {
      eyebrow: "永續發展",
      title: "今天用心耕耘\n成就明日世代",
      desc: "我們與農戶緊密合作，推廣永續的耕作方式，共創更綠色、更健康的未來。",
      cta: "我們的承諾",
      features: [
        { title: "支持農戶" },
        { title: "環境責任" },
        { title: "壯大社區" },
      ],
    },
  },
  aboutPage: {
    hero: {
      eyebrow: "關於 EVERRICE",
      title: "扎根越南，走向全球",
      desc: "一家值得信賴的越南大米出口企業，致力於品質與誠信，並與農民及全球大米進口商建立長久的合作夥伴關係。",
    },
    story: {
      eyebrow: "我們的故事",
      title: "從一家小型大米出口商到值得信賴的全球夥伴",
      p1: "EverRice 最初只是一家小型越南大米出口企業，堅守對品質、誠信與信任的樸實承諾。透過與農戶和客戶的緊密合作，我們在每一次出貨和每一段關係中不斷成長。",
      p2: "如今，我們將越南最優質的稻米與全球大米進口商相連。雖然我們的版圖不斷擴大，但我們的價值始終如一——建立長久的合作夥伴關係，交付值得信賴的品質。",
      ctaProducts: "我們的產品",
      ctaContact: "聯繫我們",
    },
    pillars: {
      eyebrow: "驅動我們的力量",
      title: "使命、願景與價值觀",
      items: [
        {
          title: "我們的使命",
          desc: "將優質的越南大米帶給世界，同時與農民及全球大米進口商建立長久的合作夥伴關係。",
        },
        {
          title: "我們的願景",
          desc: "成為全球市場中最值得信賴的越南大米合作夥伴，以品質與誠信著稱。",
        },
        {
          title: "我們的價值觀",
          desc: "品質至上。永續成長。誠信。誠實合作。尊重。",
        },
      ],
    },
    values: {
      eyebrow: "核心價值觀",
      title: "指引我們的原則",
      items: [
        { title: "品質至上", desc: "我們絕不妥協所交付產品的品質。" },
        {
          title: "永續成長",
          desc: "我們著眼長期成功，為合作夥伴與我們所在的社區創造價值。",
        },
        {
          title: "誠信",
          desc: "我們做正確的事，信守承諾，並為自己的行為負責。",
        },
        {
          title: "誠實合作",
          desc: "我們相信長久的商業關係建立在透明、信任與共贏之上。",
        },
        {
          title: "尊重",
          desc: "我們珍視農戶、合作夥伴、客戶，以及每一位為我們的旅程做出貢獻的人。",
        },
      ],
    },
    facilities: {
      eyebrow: "每一粒米背後",
      title: "從稻田到您的港口",
      sub: "一條完全可追溯的鏈條——採購、碾磨與檢測。",
      items: [
        { title: "源自湄公河三角洲" },
        { title: "在現代化工廠中加工" },
        { title: "經認證實驗室檢測" },
      ],
    },
    stats: [
      { value: "14", label: "年專業經驗" },
      { value: "15+", label: "出口國家" },
      { value: "4萬", label: "噸/月供應能力" },
      { value: "20萬", label: "年發貨噸數" },
    ],
  },
  productsPage: {
    hero: {
      eyebrow: "我們的產品",
      title: "越南好米,成就美好未來",
      desc: "從優質香米到高品質白米、糯米及特色米種，EverRice 自豪地將越南優質大米帶上世界各地的餐桌。",
    },
    grid: {
      categories: [
        { key: "all", label: "全部產品" },
        { key: "fragrant", label: "香米" },
        { key: "white", label: "白米" },
        { key: "brown", label: "糯米" },
        { key: "specialty", label: "特色米" },
      ],
      labels: { grade: "粒長", packing: "包裝", moisture: "水分" },
      items: [
        {
          cat: "fragrant",
          name: "茉莉香米",
          desc: "柔軟、芬芳、自然回甜——我們的招牌泰式茉莉香米長粒米。",
          grade: "優質 5% 碎米",
          packaging: "1kg / 5kg / 25kg / 50kg",
          moisture: "最高 14%",
        },
        {
          cat: "fragrant",
          name: "香長粒米",
          desc: "帶有淡淡的班蘭葉香氣，質地輕盈蓬鬆，煮後依然柔軟。",
          grade: "優質 5% 碎米",
          packaging: "5kg / 10kg / 25kg",
          moisture: "最高 14%",
        },
        {
          cat: "fragrant",
          name: "ST25 香米",
          desc: "屢獲殊榮的優質長粒米，米粒柔軟，自然回甜，香氣淡雅。",
          grade: "優質 5% 碎米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14%",
        },
        {
          cat: "fragrant",
          name: "香花米",
          desc: "米粒細長的香米，以淡雅花香與柔韌口感著稱。",
          grade: "優質 5% 碎米",
          packaging: "5kg / 10kg / 25kg",
          moisture: "最高 14%",
        },
        {
          cat: "white",
          name: "白米 5%",
          desc: "日常標準之選——潔淨、穩定，非常適合日常餐飲和配餐。",
          grade: "5% 碎米",
          packaging: "10kg / 25kg / 50kg",
          moisture: "最高 14%",
        },
        {
          cat: "white",
          name: "白米 15%",
          desc: "高性價比的可靠等級，適合餐飲、加工及大批量採購客戶。",
          grade: "15% 碎米",
          packaging: "25kg / 50kg",
          moisture: "最高 14%",
        },
        {
          cat: "white",
          name: "白米 10%",
          desc: "均衡的日常等級——潔淨、順滑、精碾，適合日常烹飪與配餐。",
          grade: "10% 碎米",
          packaging: "25kg / 50kg",
          moisture: "最高 14%",
        },
        {
          cat: "white",
          name: "日本米",
          desc: "短圓粒，油亮黏糯——壽司與日式料理的理想之選。",
          grade: "短粒",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14%",
        },
        {
          cat: "brown",
          name: "糙米",
          desc: "保留麩皮的全穀米——堅果香、營養豐富、富含膳食纖維。",
          grade: "全穀米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
        {
          cat: "brown",
          name: "紅米",
          desc: "別具一格的紅色麩皮，口感緊實，帶有溫暖質樸的風味。",
          grade: "全穀米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
        {
          cat: "brown",
          name: "白糯米",
          desc: "油亮、柔韌、自然黏糯——節慶佳餚與傳統甜點的經典之選。",
          grade: "全穀米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
        {
          cat: "brown",
          name: "班蘭糯米",
          desc: "帶有淡淡班蘭香氣的香糯米，色澤柔和微綠。",
          grade: "全穀米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
        {
          cat: "specialty",
          name: "黑糯米",
          desc: "油亮、自然甘甜、黏糯——傳統甜點的理想之選。",
          grade: "全穀米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
        {
          cat: "specialty",
          name: "有機茉莉香米",
          desc: "獲得有機認證，不使用合成農藥種植，成就最潔淨的餐桌。",
          grade: "有機認證",
          packaging: "1kg / 5kg",
          moisture: "最高 14%",
        },
        {
          cat: "specialty",
          name: "發芽糙米",
          desc: "富含 GABA 的發芽糙米——營養升級，口感更柔軟、更具堅果香。",
          grade: "發芽米",
          packaging: "1kg / 5kg",
          moisture: "最高 14%",
        },
        {
          cat: "specialty",
          name: "紅血米",
          desc: "罕見的深紅珍稀米種，色澤濃郁，口感緊實、營養豐富。",
          grade: "全穀米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
      ],
    },
    certs: {
      eyebrow: "品質保證",
      title: "每一步都獲得認證",
      desc: "每一批大米在出廠前都會經過純度、水分和食品安全檢測。",
      items: [
        { title: "HACCP", desc: "通過食品安全管理認證" },
        { title: "ISO 22000", desc: "全球食品安全標準" },
        { title: "有機認證", desc: "獲得認證的有機品種" },
        { title: "GLOBALG.A.P.", desc: "負責任的耕作規範" },
      ],
    },
    packaging: {
      eyebrow: "靈活的選擇",
      title: "為每一位買家量身包裝",
      items: [
        { title: "零售包裝", desc: "1kg、2kg 和 5kg 零售裝，適合超市和電商。" },
        {
          title: "大包裝",
          desc: "25kg 和 50kg 編織袋或紙袋，適合分銷商和加工商。",
        },
        {
          title: "整櫃運輸",
          desc: "20 尺和 40 尺整櫃運輸，提供靈活的 FCL 與 LCL 條款。",
        },
      ],
      box: {
        title: "需要客製規格嗎？",
        desc: "告訴我們您的等級、數量與目的地——我們將為您準備專屬報價。",
        cta: "索取報價",
      },
    },
  },
  qualityPage: {
    hero: {
      eyebrow: "品質保障",
      title: "粒粒好米,品質見真章",
      desc: "穩定的標準、嚴格的檢測與完整的可追溯性—這正是我們贏得超過 15 個國家買家信任的方式。",
    },
    intro: {
      eyebrow: "我們的承諾",
      title: "我們始終堅守的標準",
      desc: "好米並非偶然。它源自精心挑選的稻穀、精準的碾磨，以及每一個檢查環節的坦誠。我們的團隊對每一批貨進行檢驗，確保出廠的產品正是合作夥伴所期望的——批次如一。",
      highlights: [
        {
          title: "每批都經實驗室檢測",
          desc: "每一批貨在批准前都會抽樣分析水分、純度與碎米率。",
        },
        {
          title: "全程可追溯",
          desc: "從稻田到貨櫃編號——每一步都有記錄、可驗證。",
        },
        {
          title: "認證標準",
          desc: "營運符合 HACCP、ISO 22000 和 GLOBALG.A.P. 食品安全框架。",
        },
      ],
    },
    process: {
      eyebrow: "我們的流程",
      title: "五大檢查點，一份對品質的承諾",
      items: [
        {
          step: "01",
          title: "產地甄選",
          desc: "我們精選來自認證種植區域合作農場的稻穀，確保來源可追溯至具體田塊。",
        },
        {
          step: "02",
          title: "可控碾磨",
          desc: "採用現代化工廠，配備已校準的脫殼與拋光工序，達到一致的碾磨精度。",
        },
        {
          step: "03",
          title: "實驗室檢測",
          desc: "對樣品進行水分、碎米、雜質和食品安全指標的檢測。",
        },
        {
          step: "04",
          title: "精準包裝",
          desc: "在受控條件下使用潔淨的食品級包裝，按訂單封口並貼標。",
        },
        {
          step: "05",
          title: "出貨文件齊全",
          desc: "每批貨物均隨附質量證明及檢測分析報告，確保全程透明、資訊清晰。",
        },
      ],
    },
    specs: {
      eyebrow: "技術標準",
      title: "我們所檢測的指標",
      sub: "典型的出口規格。最終參數按合約與每位買家協商確定。",
      head: { param: "指標", standard: "標準", method: "檢測方法" },
      rows: [
        { param: "水分含量", standard: "最高 14.0%", method: "ISO 712" },
        { param: "碎米率", standard: "按等級 5% / 15%", method: "ISO 7301" },
        { param: "雜質", standard: "最高 0.10%", method: "目視與過篩" },
        { param: "稻穀粒", standard: "每公斤最多 5 粒", method: "人工計數" },
        { param: "碾磨精度", standard: "精碾", method: "目視評估" },
        { param: "白度指數", standard: "40+", method: "白度儀" },
      ],
    },
    labs: {
      eyebrow: "幕後花絮",
      title: "品質誕生的地方",
      items: [
        { title: "稻米檢驗" },
        { title: "檢測實驗室" },
        { title: "可控倉儲" },
      ],
    },
    certs: {
      eyebrow: "獲得國際認可",
      title: "層層把關，認證保障",
      desc: "透過獨立審核及國際認可的認證體系，切實印證我們對合作夥伴所作出的品質承諾。",
      items: [
        { title: "HACCP", desc: "危害分析與關鍵控制點" },
        { title: "ISO 22000", desc: "全球食品安全管理" },
        { title: "有機認證", desc: "獲得認證的有機品種" },
        { title: "GLOBALG.A.P.", desc: "負責任的耕作規範" },
      ],
    },
    stats: [
      { value: "100%", label: "批次經實驗室檢測" },
      { value: "24小時", label: "平均檢測週轉時間" },
      { value: "0.1%", label: "最大雜質含量" },
      { value: "5", label: "品質檢查關卡" },
    ],
    cta: {
      title: "索取我們的品質文件",
      desc: "每筆訂單均可提供規格說明、分析證書及檢驗報告。告訴我們您的需求，我們將為您準備好相關細節。",
      ctaContact: "聯繫我們",
      ctaProducts: "我們的產品",
    },
  },
  sustainabilityPage: {
    hero: {
      eyebrow: "永續發展",
      title: "責任耕耘，共創未來",
      desc: "我們相信，優質大米不應以環境為代價。每一次收穫，都是守護土地、關愛農民、回饋社區的機會。",
    },
    intro: {
      eyebrow: "我們的理念",
      title: "今天用心耕耘，成就明日世代",
      p1: "我們與耕耘稻田的種植者並肩合作，分享知識，並投資於保護土壤、節約用水、保障其生計的實踐。",
      p2: "從田間到工廠，我們減少浪費、使用更清潔的能源，並讓供應鏈保持透明，讓每一袋大米都承載更輕的足跡與更公平的故事。",
      ctaQuality: "我們的品質",
      ctaWork: "與我們合作",
    },
    pillars: {
      eyebrow: "我們堅守的理念",
      title: "我們承諾的三大支柱",
      items: [
        {
          title: "支持農戶",
          desc: "公平的價格、長期的合約與培訓，幫助合作家庭從容發展。",
        },
        {
          title: "環境責任",
          desc: "節水灌溉、有機耕作，以及工廠中的可再生能源應用。",
        },
        {
          title: "壯大社區",
          desc: "在我們種植大米的地方，投資當地學校、清潔水源與發展機會。",
        },
      ],
    },
    initiatives: {
      eyebrow: "切實行動",
      title: "貫穿供應鏈的舉措",
      sub: "這些具體的項目，讓我們的米對人們和地球都更好。",
      items: [
        {
          title: "節水灌溉",
          desc: "採用乾濕交替技術，在保持高產的同時減少用水量。",
        },
        {
          title: "有機耕作",
          desc: "減少化學投入、以自然方式養護土壤，培育更健康、更潔淨的稻田。",
        },
        {
          title: "公平貿易定價",
          desc: "透明的合約，為農戶的收成提供穩定而公平的收入。",
        },
        {
          title: "農戶培訓",
          desc: "田間學校為合作種植者傳授現代化、永續的技術。",
        },
        { title: "可再生能源", desc: "太陽能與生物質能為碾米作業降低碳足跡。" },
        {
          title: "減少浪費",
          desc: "稻殼和米糠被再利用為生物質燃料和動物飼料，而非廢棄。",
        },
      ],
    },
    goals: {
      eyebrow: "我們的 2030 目標",
      title: "我們前行的方向",
      items: [
        {
          value: "100%",
          label: "負責任採購的大米",
          desc: "到 2030 年，全部大米採購自認證的永續種植者。",
        },
        {
          value: "30%",
          label: "減少用水量",
          desc: "降低合作農場每噸稻穀的灌溉用水。",
        },
        {
          value: "50%",
          label: "可再生能源",
          desc: "一半的碾米能源來自太陽能與生物質能。",
        },
        {
          value: "20,000",
          label: "培訓農戶",
          desc: "擴大我們的永續農耕教育項目。",
        },
      ],
    },
    stats: [
      { value: "12,000", label: "受支持的合作農戶" },
      { value: "4,500 公頃", label: "永續耕作面積" },
      { value: "30%", label: "每次收穫節省的用水" },
      { value: "18", label: "年攜手成長" },
    ],
    cta: {
      title: "與我們攜手，共創更美好的事物",
      desc: "與一家關心品質、人們與地球的大米出口企業合作。讓我們共同打造更具責任感的供應鏈。",
      ctaContact: "聯繫我們",
      ctaProducts: "我們的產品",
    },
  },
  globalReachPage: {
    hero: {
      eyebrow: "全球市場",
      title: "從越南走向世界",
      desc: "我們向亞洲、北美、歐洲、非洲及其他地區的市場供應優質大米。",
      cta: "我們的市場",
      stats: [
        { value: "30+", label: "國家與地區" },
        { value: "100+", label: "信賴合作夥伴" },
        { value: "1M+", label: "年供應噸數" },
      ],
    },
    overview: {
      eyebrow: "我們的網絡",
      title: "一條供應鏈，多個市場",
      p1: "EverRice 將湄公河三角洲肥沃的稻田與全球各地的進口商、分銷商和零售商相連。二十多年來，我們建立了長期的合作關係，讓單次訂單轉變為可靠的夥伴關係。",
      p2: "從出口單據和品質證書，到客製包裝與發運計劃，我們的團隊處理每一個細節，讓您的貨架持續充盈——一季又一季。",
      ctaProducts: "我們的產品",
      ctaQuote: "索取報價",
      stats: [
        { value: "25+", label: "出口市場" },
        { value: "20萬", label: "年發貨噸數" },
        { value: "5", label: "服務的大洲" },
        { value: "24小時", label: "報價回應時間" },
      ],
    },
    map: {
      eyebrow: "出口市場",
      title: "讓優質越南大米走向世界",
      labels: {
        markets: "市場",
        ofVolume: "佔出貨量",
        growth: "成長",
        keyMarkets: "核心市場",
        viewAria: "檢視出口數據",
      },
      countries: {
        spain: "西班牙",
        austria: "奧地利",
        dubai: "杜拜",
        ghana: "迦納",
        russia: "俄羅斯",
        canada: "加拿大",
        usa: "美國",
        china: "中國",
        hongkong: "香港",
        philippines: "菲律賓",
        malaysia: "馬來西亞",
        singapore: "新加坡",
        indonesia: "印尼",
        australia: "澳洲",
        solomon: "索羅門群島",
      },
      regions: [
        {
          name: "亞洲",
          tagline: "我們最大、歷史最悠久的市場",
          desc: "從東京到馬尼拉，我們的香米和白米是亞洲餐桌上的可靠主糧——按長期合約全年供應。",
          growth: "同比 +12%",
          volume: "19 萬噸",
          markets: ["日本", "菲律賓", "中國", "韓國", "新加坡", "馬來西亞"],
        },
        {
          name: "中東",
          tagline: "快速成長的合作夥伴地區",
          desc: "我們為海灣地區的酒店、零售商和分銷商供應穩定、精碾、貼合當地口味並符合清真要求的大米。",
          growth: "同比 +18%",
          volume: "13 萬噸",
          markets: ["阿聯酋", "沙烏地阿拉伯", "卡達", "科威特", "阿曼"],
        },
        {
          name: "歐洲",
          tagline: "為挑剔買家提供優質品質",
          desc: "歐洲進口商信賴我們可追溯的供應鏈、嚴格的品質控制，以及每個貨櫃都可靠的單據。",
          growth: "同比 +9%",
          volume: "9.5 萬噸",
          markets: ["德國", "荷蘭", "波蘭", "英國", "法國"],
        },
        {
          name: "非洲",
          tagline: "攜手共建糧食安全",
          desc: "我們以可靠的貨源和靈活的包裝方案，支持西非和南部非洲的批發商及援助項目。",
          growth: "同比 +15%",
          volume: "5.5 萬噸",
          markets: ["迦納", "象牙海岸", "南非"],
        },
        {
          name: "美洲",
          tagline: "拓展新的海岸",
          desc: "這是 EverRice 較新的市場，我們以正宗的越南品種，服務北美各地的亞洲食品零售商和分銷商。",
          growth: "同比 +21%",
          volume: "3 萬噸",
          markets: ["美國", "加拿大"],
        },
      ],
    },
    regionStats: {
      eyebrow: "用數據說話",
      title: "我們的規模與實力",
      sub: "我們五個目的地地區的年度參考量。",
      marketsUnit: "個目的地市場",
      shareUnit: "的出口總量",
    },
    keyMarkets: {
      eyebrow: "核心目的地",
      title: "深受全球買家信賴",
      items: [
        {
          country: "菲律賓",
          region: "亞洲",
          note: "大批量採購香米和白米。提供貨櫃及散貨船裝運選項。",
        },
        {
          country: "中國",
          region: "亞洲",
          note: "大批量採購香米和糯米。主要以貨櫃裝運。",
        },
        {
          country: "新加坡",
          region: "亞洲",
          note: "區域食品分銷、批發與餐飲貿易中心。",
        },
        {
          country: "中國香港",
          region: "亞洲",
          note: "香米與壽司米的高端市場。",
        },
      ],
    },
    logistics: {
      eyebrow: "從稻田到港口",
      title: "優化物流，簡化流程",
      items: [
        {
          title: "採購與碾磨",
          desc: "稻穀取自合作農場，並在我們現代化、嚴控品質的工廠中碾磨。",
        },
        {
          title: "品質檢驗",
          desc: "每一批貨在批准前都會經過水分、碎米和純度的實驗室檢測。",
        },
        {
          title: "包裝與裝櫃",
          desc: "按您的確切規格進行袋裝或散裝貨櫃裝箱及打托。",
        },
        {
          title: "海運",
          desc: "經由越南主要港口發運，全程處理完整的出口單據。",
        },
        {
          title: "交付與支持",
          desc: "準時抵達您選擇的港口，並配有專屬客戶經理。",
        },
      ],
    },
    compliance: {
      eyebrow: "出口就緒",
      title: "文件與合規，全程處理",
      desc: "從出口文件和品質證書，到客製化包裝與運輸安排，我們的團隊全程處理各項細節，確保您的貨物順利清關，避免任何延誤。",
      items: [
        {
          title: "HACCP 與 ISO 22000",
          desc: "貫穿我們整個碾米業務的食品安全管理。",
        },
        {
          title: "植物檢疫證書",
          desc: "為每批出口貨物簽發的官方植物衛生文件。",
        },
        { title: "原產地證書", desc: "供海關使用的、確認越南原產的完整單據。" },
        {
          title: "清真與潔食選項",
          desc: "可為中東及其他買家提供符合要求的加工處理。",
        },
      ],
    },
    cta: {
      title: "讓我們把大米運往您的市場",
      desc: "告訴我們您的目的港、數量和包裝需求——我們的出口團隊將在一個工作日內回覆專屬報價。",
      ctaContact: "聯繫銷售",
      ctaQuality: "我們的品質",
    },
  },
  contactPage: {
    hero: {
      eyebrow: "聯繫我們",
      title: "來聊聊吧",
      desc: "無論您需要報價、產品樣品，還是長期供應夥伴，我們的出口團隊都隨時為您提供幫助。",
    },
    main: {
      eyebrow: "與我們聯繫",
      title: "期待您的來信",
      desc: "請透過下方表單或聯繫方式與我們取得聯繫。我們的出口專員會在一個工作日內回覆每一封諮詢。",
      info: [
        {
          label: "到訪地址",
          value: "越南 胡志明市 富壽坊 3/2 街 968 號 The Everrich",
        },
        { label: "電子郵件", value: "info@everrice.vn" },
        { label: "聯繫電話", value: "+84 918335899" },
        { label: "工作時間", value: "週一至週六，8:00 – 17:00（GMT+7）" },
      ],
      ctaProducts: "瀏覽產品",
      ctaReach: "全球市場",
    },
    form: {
      title: "給我們留言",
      note: "帶 * 的欄位為必填項。",
      name: "姓名",
      namePh: "您的全名",
      email: "電子郵件",
      emailPh: "you@company.com",
      phone: "電話",
      phonePh: "+84 ...",
      message: "留言內容",
      messagePh: "請告訴我們您的目標市場、數量和包裝需求……",
      submit: "發送訊息",
      sending: "發送中……",
      success: "謝謝您！您的訊息已發送——我們會盡快與您聯繫。",
      errorDefault: "未能發送您的訊息，請重試。",
      network: "網路出現異常，請檢查網路連線後重試。",
      extraLabel: "補充資訊",
    },
    map: {
      eyebrow: "找到我們",
      title: "歡迎來到永禾",
    },
  },
};
